/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
var routes = [{
  path: '/',
  redirect: '/address'
}, {
  path: '/address',
  meta: {
    title: '售后单',
    skipAuth: true
  },
  component: function component() {
    return import('@/views/home/index');
  }
}, {
  path: '/queryLogistics',
  meta: {
    title: '物流信息',
    skipAuth: true
  },
  component: function component() {
    return import('@/views/home/queryLogistics');
  }
}, {
  path: '/BindWechat',
  meta: {
    title: '提示',
    skipAuth: true
  },
  component: function component() {
    return import('@/views/home/BindWechat');
  }
}];
var router = new VueRouter({
  routes: routes,
  // 点击浏览器的前进后退或切换导航触发
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || {
      x: 0,
      y: 0
    };
  }
});
export default router;